import script from "./login.vue?vue&type=script&setup=true&lang=js"
export * from "./login.vue?vue&type=script&setup=true&lang=js"

import "./login.vue?vue&type=style&index=0&id=cc5a0b64&lang=less&scoped=true"

import exportComponent from "/Users/timetravel/code/energy-storage-intelligence/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc5a0b64"]])

export default __exports__